import { DownOutlined } from "@ant-design/icons";
import { Divider, Dropdown, Menu, theme } from "antd";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { cloneElement, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { DEMO_APP_ID, ROUTES } from "../../common/constants";
import { demoAppData } from "../../mock/demoApp";
import { applicationStores } from "../../pages/Application/ApplicationStores";
import { applicationDetailStores } from "../../pages/ApplicationDetail/ApplicationDetailStores";

const AppSelector = observer(() => {
  const history = useHistory();
  const arrApplication = toJS(applicationStores.arrApplication);
  const currentApp = toJS(applicationStores.currentApp);

  const { t } = useTranslation();
  const { token } = theme.useToken();

  useEffect(() => {
    if (!currentApp) applicationStores.getAllApplication();
  }, [currentApp]);

  useEffect(() => {
    if (currentApp?.app_id && currentApp?.partner_code) {
      applicationDetailStores.getEvents(currentApp?.app_id, currentApp?.partner_code);
    }
  }, [currentApp?.app_id, currentApp?.partner_code]);

  const appItems = (arrApplication || []).map((item) => ({
    key: item.app_id,
    label: item.app_name || item.app_id,
  }));

  const actionItems = [
    { key: DEMO_APP_ID, label: "Airflex Demo" },
    {
      key: "Airflex_application_list",
      label: t("Application List"),
    },
  ];

  const onMenuClick = ({ key }) => {
    window.AirflexJS.logEvent("click_app_selector", { key });
    if (key === "Airflex_application_list") history.push(ROUTES.application);
    else if (key === DEMO_APP_ID) {
      applicationStores.setCurrentApp(demoAppData);
    } else {
      const app = arrApplication.find((a) => a.app_id === key);
      applicationStores.setCurrentApp(app);
    }
  };

  return currentApp ? (
    <Dropdown
      menu={{
        items: appItems,
        onClick: onMenuClick,
        selectable: true,
        defaultSelectedKeys: [currentApp.app_id],
      }}
      trigger={["click"]}
      className="cursor-pointer"
      overlayClassName="w-64"
      dropdownRender={(menu) => (
        <div
          style={{
            backgroundColor: token.colorBgElevated,
            borderRadius: token.borderRadiusLG,
            boxShadow: token.boxShadowSecondary,
            overflow: "hidden",
          }}
        >
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            {cloneElement(menu, { style: { boxShadow: "none" } })}
          </div>
          <Divider style={{ margin: 0 }} />
          <Menu items={actionItems} onClick={onMenuClick} selectable={false} style={{ boxShadow: "none" }} />
        </div>
      )}
    >
      <span className="d-flex align-items-center text-white">
        <span className="mr-2 text-ellipsis whitespace-nowrap word-break-word overflow-hidden">
          {currentApp?.app_name || currentApp?.app_id}
        </span>
        <DownOutlined className="h6 text-white mt-2" />
      </span>
    </Dropdown>
  ) : (
    <div />
  );
});

export default AppSelector;
